{
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "nav": {
    "forSubscriber": "For subscriber:",
    "readEpaper": "Read E-Paper",
    "readEpaperShort": "Read"
  },
  "hero": {
    "headline": "The news, laid out like the page it was printed to be.",
    "subheadline": "No feed. No noise. Just the publication's own front page curated by its editors, quiet on your eyes, and yours to keep even offline.",
    "cta": "Get E-Paper"
  },
  "feature": {
    "heading": "Four things print\ncould never do.",
    "read": {
      "chip": "Read",
      "title": "The printed page, as it is",
      "deviceAlt": "The Straits Times front page in the E-Paper reader"
    },
    "zoom": {
      "chip": "Zoom",
      "title": "Lean in and magnify",
      "deviceAlt": "An article magnified in the E-Paper reader"
    },
    "layout": {
      "chip": "Layout",
      "title": "A digital layout, built for reading",
      "deviceAlt": "An article in the E-Paper reader's digital layout"
    },
    "share": {
      "chip": "Share",
      "title": "Stories worth sharing",
      "deviceAlt": "A front page with the share and download tools open in the E-Paper reader"
    }
  },
  "startReading": "Start reading E-Paper",
  "subscription": {
    "label": "Subscription",
    "heading": "Your chosen title, every morning with 14 days of past issues always within reach",
    "pricePrefix": "from",
    "priceSuffix": "/ month",
    "cta": "Subscribe",
    "slideAlt": "{{publication}} shown in the E-Paper reader",
    "pubs": {
      "zb": {
        "label": "订阅配套",
        "heading": "超值订阅\n畅读每日新闻，14天电子报库供随时查阅",
        "pricePrefix": "每月",
        "priceSuffix": "起",
        "cta": "立即订阅",
        "name": "联合早报"
      },
      "sm": {
        "label": "订阅配套",
        "heading": "超值订阅\n畅读每日新闻，14天电子报库供随时查阅",
        "pricePrefix": "每月",
        "priceSuffix": "起",
        "cta": "立即订阅",
        "name": "新明日报"
      },
      "bh": {
        "heading": "Tajuk pilihan anda, setiap pagi dengan 14 hari isu lepas sentiasa dalam jangkauan",
        "pricePrefix": "Dari",
        "priceSuffix": "/ bulan",
        "cta": "Langgan"
      },
      "tm": {
        "heading": "நீங்கள் தேர்ந்தெடுத்த இதழ், ஒவ்வொரு காலையிலும் கடந்த 14 நாட்களின் இதழ்களுடன் எப்போதும் உங்கள் கைக்கு எட்டும் தூரத்தில்.",
        "pricePrefix": "மாதத்திற்கு",
        "priceSuffix": "முதல்",
        "cta": "சந்தா சேருங்கள்"
      }
    }
  },
  "singleCopy": {
    "label": "Single copy E-Paper",
    "heading": "Instant, like the newsstand",
    "pricePrefix": "from",
    "priceSuffix": "/ issue",
    "cta": "Buy one issue",
    "imageAlt": "A phone displaying the E-Paper app with a physical newspaper page emerging from the screen"
  },
  "plans": {
    "included": "What's included",
    "subscription": {
      "benefits": {
        "default": [
          "Premium content access",
          "Daily E-paper with 14-day archive"
        ],
        "st": [
          "Premium content access",
          "Daily E-paper with 14-day archive",
          "MyST"
        ]
      }
    },
    "single": {
      "benefits": {
        "default": [
          "The day's full issue",
          "Read on three devices at once",
          "Available for 14 days"
        ]
      }
    }
  },
  "selector": {
    "aria": "Choose a publication"
  },
  "publications": {
    "st": "The Straits Times",
    "zb": "Lianhe Zaobao",
    "sm": "Shin Min Daily News",
    "tm": "Tamil Murasu",
    "bt": "The Business Times",
    "bh": "Berita Harian"
  },
  "links": {
    "buyToday": "https://subscribe.sph.com.sg/pages/epaper/buy?utm_campaign=singlecopyepaper&utm_medium=sph-publication&utm_source=epaperlp&utm_content=purchaselink-epaperlp-singlecopy",
    "publications": {
      "st": "https://subscribe.sph.com.sg/publications-st?utm_campaign=st_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-st",
      "zb": "https://subscribe.sph.com.sg/publications-zb?utm_campaign=zb_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-zb",
      "sm": "https://subscribe.sph.com.sg/publications-sm?utm_campaign=sm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-sm",
      "tm": "https://subscribe.sph.com.sg/publications-tm?utm_campaign=tm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-tm",
      "bt": "https://subscribe.sph.com.sg/publications-bt?utm_campaign=bt_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bt",
      "bh": "https://subscribe.sph.com.sg/publications-bh?utm_campaign=bh_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bh"
    }
  },
  "footer": {
    "about": "About",
    "promotions": "Promotions",
    "subscriptionTerms": "Standard Subscription Terms and Conditions",
    "termsConditions": "Terms and Conditions",
    "cookieNotice": "Cookie Policy",
    "personalDataProtection": "Personal Data Protection",
    "officialDomains": "Official Domains",
    "contactUs": "Contact Us",
    "onlineForm": "Online form",
    "generalEnquiries": "General enquiries:",
    "corporateEnquiries": "For corporate:",
    "copyright": "Copyright © {{year}} SPH Media Limited. Co. Regn. No. 198402868E. All Rights Reserved.",
    "address": "1000 Toa Payoh North Annexe Level 6, News Centre Singapore 318994"
  },
  "footerLinks": {
    "promotions": "https://subscribe.sph.com.sg/promotions-listing/",
    "subscriptionTerms": "https://subscribe.sph.com.sg/tnc/standard/",
    "termsConditions": "https://www.sph.com.sg/legal/website_tnc/",
    "cookieNotice": "https://www.sph.com.sg/tnc/cookie/",
    "personalDataProtection": "https://www.sph.com.sg/tnc/pdpa/",
    "officialDomains": "https://www.sph.com.sg/officialdomains/",
    "onlineForm": "https://subscribe.sph.com.sg/contact-us/"
  },
  "heroTitle": "Subscribe today for full E-paper access and a 14-day archive",
  "heroSubtitle": "Read it your way: switch seamlessly between the classic print-style layout and a mobile-friendly HTML article view.",
  "or": "or",
  "singleCopyTitle": "Read today's E-paper, no strings attached.",
  "singleCopySubtitle": "Buy a single copy instantly - no recurring charges, no long-term commitment.",
  "buyToday": "Buy today's E-paper"
}
